import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useCompletedLessonMutation } from "../../store/courses";
import moment from "moment";
import AdminInvoiceTable from "../admin/dashboard/dashboardAdminInvoice/tables/AdminInvoiceTable";
import { XMarkIcon } from "@heroicons/react/24/outline";
import AdminUserInvoiceTable from "../admin/dashboard/dashboardAdminInvoice/tables/AdminUserInvoiceTable";

const UserInvoicesModal = ({ showModal, setShowModal,allInvoicesData,userInfoDetail,getUpdateData }) => {
    const [invoices,setInvoices] = useState([])

useEffect(()=>{
    setInvoices(allInvoicesData)
},[allInvoicesData,userInfoDetail])

  return (
    <>
    <Transition.Root show={showModal} as={Fragment}>
          <Dialog as="div" className="relative z-50" onClose={() => setShowModal(false)}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
              <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative transform overflow-hidden rounded-[10px] bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-[90%] px-5 md:px-10 py-6 md:py-8">
                   {invoices&&<div className="flex items-center justify-between mb-5 md:mb-0">
                        <h6 className="text-base md:text-xl font-bold leading-[160%] text-customGray">All Invoices <span className="text-primary">({userInfoDetail?.first_name??""} {userInfoDetail?.last_name??""})</span> </h6>
                        <XMarkIcon className="w-6 h-6 cursor-pointer hover:text-[#EF2121]" onClick={() => setShowModal(false)} />
                    </div>}
                    <AdminUserInvoiceTable
                      invoices={invoices}
                      userInfoDetail={userInfoDetail}
                      getUpdateData={getUpdateData}
                    />
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
    </>
  );
};

export default UserInvoicesModal;
